import { Drawer, DRAWER_SLOTS, TYPES } from '@/packages/ev-drawers/drawers';
import { createOverlayRegistry } from '@/packages/ev-overlays/registry';

export default {
  install(Vue) {
    const registry = createOverlayRegistry(Vue);

    const addNewDrawer = (type, options = {}) => {
      const drawer = new Drawer({ ...options, type });
      return registry.add(drawer);
    };

    Vue.prototype.$drawers = {
      portal: (options = {}) => addNewDrawer(TYPES.portal, options),
      form: (options = {}) => addNewDrawer(TYPES.form, options),
      list: registry.list,
      get: registry.get,
      has: registry.has,
      close: registry.close,
      remove: registry.remove,
      resetAll: registry.resetAll,
      types: TYPES,
      slots: DRAWER_SLOTS,
    };
  },
};
